import React from 'react'
import { Modal, Box } from '@mui/material';
import { getApiEstadoCobranzaContrato } from '../../API/ApiEstadoCobranzaContrato';
import { AuthContext } from '../../auth/authContext';
import { toast } from 'react-toastify';

const ResumenDeContratoModalComponent = ({
    idcontrato, setResumenDeContrato
}) => {

    const [detalleContrato, setDetalleContrato] = React.useState({});
    const { user, dispatch } = React.useContext(AuthContext);


    React.useEffect(() => {
        getApiEstadoCobranzaContrato(user, idcontrato).then((resultado) => {
            if (resultado.status == 200) {
                toast.info("Mostrando el detalle del contrato");
                setDetalleContrato(resultado.data);
            }
        });
    }, [])




    const handleCloseModal = () => setResumenDeContrato(false);

    return (
        <Modal
            open={true}
            onClose={handleCloseModal}
            aria-labelledby="modal-contrato-title"
            aria-describedby="modal-contrato-description"
        >
            <Box sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                bgcolor: "background.paper",
                border: "2px solid #000",
                boxShadow: 24,
                p: 4,
            }}>
                <h5 id="modal-contrato-title">Resumen de Contrato</h5>
                {detalleContrato && (
                    <>
                        <table className="table table-sm">
                            <tbody>
                                <tr>
                                    <th>Serie</th>
                                    <td>{detalleContrato.serie}</td>
                                </tr>
                                <tr>
                                    <th>Número de Contrato</th>
                                    <td>{detalleContrato.noContrato}</td>
                                </tr>
                                <tr>
                                    <th>Titular</th>
                                    <td>{detalleContrato.titular}</td>
                                </tr>
                                <tr>
                                    <th>Servicio Contratado</th>
                                    <td>{detalleContrato?.servicioContratado?.nombre}</td>
                                </tr>
                                <tr>
                                    <th>Plazo Contrato</th>
                                    <td>{detalleContrato.plazoContrato}</td>
                                </tr>
                                <tr>
                                    <th>Fecha Inicio</th>
                                    <td>{detalleContrato.fechaInicioContrato}</td>
                                </tr>
                                <tr>
                                    <th>Fecha Fin</th>
                                    <td>{detalleContrato.fechaFinContrato}</td>
                                </tr>
                                <tr>
                                    <th>Meses Transcurridos</th>
                                    <td>{detalleContrato.mesesTranscurridosContratoHoy}</td>
                                </tr>
                                <tr>
                                    <th>Monto Pago Mensual</th>
                                    <td>{detalleContrato.montoPagoSugeridoMensual}</td>
                                </tr>
                                <tr>
                                    <th>Importe</th>
                                    <td>{detalleContrato.importe}</td>
                                </tr>
                                <tr>
                                    <th>Pagos al Momento</th>
                                    <td>{detalleContrato.pagosAlMomento}</td>
                                </tr>
                                <tr>
                                    <th>Saldo</th>
                                    <td>{detalleContrato.saldo}</td>
                                </tr>
                                <tr>
                                    <th>Fecha Último Pago</th>
                                    <td>{detalleContrato.fechaUltimoPago}</td>
                                </tr>
                                <tr>
                                    <th>Número de Pagos Capturados</th>
                                    <td>{detalleContrato.numeroPagosCapturados}</td>
                                </tr>
                                <tr>
                                    <th>Monto Vencido</th>
                                    <td>{detalleContrato.montoVencido}</td>
                                </tr>
                            </tbody>
                        </table>
                    </>
                )}

                <button className="btn btn-sm btn-secondary w-100 mt-2" onClick={handleCloseModal}>
                    Cerrar
                </button>
            </Box>
        </Modal>
    )
}

export default ResumenDeContratoModalComponent
